import env from 'react-dotenv'

const hosts = {
  UAA_URL: env.UAA_URL,
  WS_DOCAS: env.WS_DOCAS,
  WS_CADASTRO: env.WS_CADASTRO,
  WS_CHAT: env.WS_CHAT,
  // WS_CADASTRO: 'http://teste.sinivem.com.br/WsCadastro/api',
  // UAA_URL: 'http://10.0.18.30:5054/api',
  // WS_DOCAS: 'http://teste.sinivem.com.br/WsDocas/api',
  // WS_CHAT: 'http://teste.sinivem.com.br/WsChatDev/api',
  // UAA: 'https://gateway.compulog.com.br:5050/uaa',
  // WS_DOCAS: 'http://168.90.173.35/WsDocas/api',
  // WS_CHAT: ' http://168.90.173.35/WsChat/api',
}

export default hosts
